import React, { FC } from "react";

import { bem } from "@react-md/utils";
import { Divider as AntdDivider, DividerProps as AntdDividerProps } from "antd";
import cn from "classnames";

const block = bem("mmc-divider");

export interface DividerProps extends AntdDividerProps {}

const Divider: FC<DividerProps> = ({ className, ...props }) => {
  return <AntdDivider className={cn(block(), className)} {...props} />;
};

export default Divider;
